module.exports = __webpack_public_path__ + "static/media/product2.f0f7d187.png";